"use client";

import { useCallback, useSyncExternalStore } from "react";
import {
  readBrowserPreference,
  subscribeBrowserPreferences,
  writeBrowserPreference,
} from "@workspace/gamja-platform/lib/browser-preference";

export const LEFT_SIDEBAR_DEFAULT_KEY = "jcg:left-sidebar-default-collapsed";
export const RIGHT_SIDEBAR_DEFAULT_KEY = "jcg:right-sidebar-default-collapsed";

/** null means the user has not chosen a default; compact auto-collapse still applies. */
export function useSidebarDefault(key: string) {
  const stored = useSyncExternalStore(
    subscribeBrowserPreferences,
    () => readBrowserPreference(key),
    () => null,
  );
  const setDefault = useCallback(
    (collapsed: boolean | null) =>
      writeBrowserPreference(key, collapsed === null ? "auto" : String(collapsed)),
    [key],
  );
  return [
    stored === null || stored === "auto" ? null : stored === "true",
    setDefault,
  ] as const;
}
